import React from "react";
import { Link } from "react-router-dom";
import { Text, HStack, Box, Icon } from "@chakra-ui/react";
import { FiArrowUpRight } from "react-icons/fi";
import { MotionBox, MotionHeading } from "./base/motion-chakra";
import IconWithLink from "./base/IconWithLink";
import { AllowedIcons } from "../constants/types";
import { accent } from "../constants/constants";

const contactMethods: AllowedIcons[] = ["linkedIn", "email", "instagram"];
const Contact: React.FC = () => {
  return (
    <Box
      as="section"
      id="contact"
      aria-labelledby="contact-heading"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={6}
      bg="brand.bg"
      minHeight="70vh"
      scrollMarginTop={{ base: "70px", md: "90px" }}
    >
      <MotionBox
        minHeight="50vh"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: "1" }}
      >
        <MotionHeading
          id="contact-heading"
          fontSize={{ base: "4xl", md: "6xl" }}
          fontWeight={900}
          mb={6}
          initial={{ rotate: -6 }}
          whileInView={{ rotate: 0 }}
          viewport={{ once: true }}
          transition={{ duration: "0.5" }}
          maxWidth="600px"
          textAlign="center"
          color="brand.text"
        >
          <Text as="span" color={accent}>
            Let&apos;s Talk.
          </Text>
        </MotionHeading>
        <Text
          fontSize={{ base: "lg", md: "2xl" }}
          color="brand.muted"
          textAlign="center"
          maxWidth="500px"
          mb={10}
        >
          If you like what you see, get in touch with me via email or social
          media
        </Text>
        <HStack spacing={{ base: 5, md: 10 }} mb={10}>
          {contactMethods.map((method, key) => (
            <IconWithLink iconType={method} key={key}></IconWithLink>
          ))}
        </HStack>
        <Link to="/resume.pdf" target="_blank" download>
          <Text
            fontSize="md"
            fontWeight={700}
            color="brand.text"
            display="inline-flex"
            alignItems="center"
            gap={2}
            _hover={{ color: accent }}
          >
            <Icon
              as={FiArrowUpRight}
              aria-hidden="true"
              color={accent}
              boxSize={5}
            />
            Or, view my Resume
          </Text>
        </Link>
      </MotionBox>
    </Box>
  );
};

export default Contact;
